import { Stack, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import React, { SyntheticEvent, useCallback, useMemo, useState } from 'react'
import {
  AdminStatus,
  AdminStatusOptions,
  EOp,
  FilterModelDate,
  FilterModelText,
  Nullish,
} from 'types'

export function useAdminStatusFilter() {
  const [statusValue, setStatusValue] = useState<{ value: AdminStatus; label: string }[]>([])

  const statusFilterValue: Nullish<FilterModelDate | FilterModelText> = useMemo(() => {
    // if statusValue includes only INACTIVE, send filter for licenseExpiredAt not null
    if (!!statusValue.length && statusValue.every((item) => item.value === AdminStatus.INACTIVE)) {
      return {
        type: 'date',
        op: EOp.notBlank,
      } as FilterModelDate
    }

    // if statusValue includes only ACTIVE, send filter for licenseExpiredAt null
    if (!!statusValue.length && statusValue.every((item) => item.value === AdminStatus.ACTIVE)) {
      return {
        type: 'text',
        op: EOp.blank,
      } as FilterModelText
    }

    return null
  }, [statusValue])

  const handleChange = useCallback(
    (_: SyntheticEvent, newValue: { value: AdminStatus; label: string }[]) => {
      setStatusValue(newValue)
    },
    [setStatusValue],
  )

  const StatusFilter = useMemo(() => {
    return (
      <Stack direction="row" alignItems="center" className="gap-8">
        <Typography>Status</Typography>

        <Autocomplete
          multiple
          options={AdminStatusOptions}
          value={statusValue}
          onChange={handleChange}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              name="role"
              InputProps={{
                ...params.InputProps,
                endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
              }}
            />
          )}
        />
      </Stack>
    )
  }, [handleChange, statusValue])

  return { StatusFilter, statusFilterValue }
}
